import { AuditLog } from '@/common/model/analytics'

export const AuditLogApiPath = {
  LIST_AUDIT_LOGS: '/api/audit-logs', // GET List Audit Logs
  EXPORT_AUDIT_LOGS_CSV: '/api/audit-logs/csv' // GET Export Audit Logs CSV
}

export type AuditLogApiPath = (typeof AuditLogApiPath)[keyof typeof AuditLogApiPath]

export interface ListAuditLogsVars {
  site_id?: number | null
  action?: string | null
  resource_type?: string | null
  operator_name?: string | null
  date_from?: string | null
  date_to?: string | null
  page?: number
  per_page?: number
}

export interface ListAuditLogsResponse {
  items: AuditLog[]
  total: number
}
